'use strict';

import Promise from 'bluebird';

export function ApplicationFactory($http, $state, $stateParams, $timeout, $rootScope) {
	'ngInject';

	var jsonFiles = ['general', 'share', 'quantity', 'data'];

	var Application = {
	};

	Application.load = function (id, callback) {
		return new Promise(function (resolve, reject) {
			Promise.map(jsonFiles, function (name) {
				return new Promise(function (resolve, reject) {
					$http.get('/applications/' + id + '/config/' + name + '.json').then(
						function (res) {
							Application[name] = res.data;
							resolve();
						}, function (error) {

						});
				});
			}, { concurrency: 1 }).then(function () {
				resolve();
			});
		});
	}

	Application.save = function (id) {
		return new Promise(function (resolve, reject) {
		var data = {};

		_.each(jsonFiles, function (value) {
			data[value] = Application[value];
		});

		$http.post('/api/applications/' + id + '/save', data).then(function (res) {
				return resolve();
			}, function (error) {
				if (error.status == "404") {
					$state.go('application_main');
				}
				console.log(error);
			});
		});
	}

	Application.previous = function(id){
		return new Promise(function (resolve, reject) {
			Application.fetchScreen().then(Application.save(id)).then(function(){
				$state.go('application_screen_' + Application.previousScreen.name, {id: $stateParams.id});
				resolve()
			}).catch(function(err){
				console.log(err)
			})
		})
	}

	Application.next = function(id){
		return new Promise(function (resolve, reject) {
			Application.fetchScreen().then(Application.save(id)).then(function(){
				$state.go('application_screen_' + Application.nextScreen.name, {id: $stateParams.id});
				resolve();
			})
		})
	}

	Application.fetchScreen = function(){
		return new Promise(function (resolve, reject) {
			if(!Application.general) {
				return $timeout(Application.fetchScreen, 500)
			}
			var currentScreen = _.find(Application.general.storyboard ,function(ecran){
				if($state.current.name.slice($state.current.name.lastIndexOf("_") +1) == ecran.name){
					return ecran;
				}
			})
			var previousScreen, nextScreen;
			if(currentScreen.name == 'main') previousScreen = {name : 'style'};
			else {
				previousScreen = _.findLast(Application.general.storyboard, function(ecran){
					if(ecran.rank < currentScreen.rank && ecran.status == true) return ecran
				})
			}

			nextScreen = _.find(Application.general.storyboard, function(ecran){
				if(ecran.rank > currentScreen.rank && ecran.status == true) return ecran;
			})

			//Handle "quantity" screen
			if(previousScreen && previousScreen.name == 'quantity' && Application.quantity.maxNumber == 1) {
				previousScreen = _.findLast(Application.general.storyboard, function(ecran){
					if(ecran.rank < previousScreen.rank && ecran.status == true) return ecran;
				})
			}
			if(nextScreen && nextScreen.name == 'quantity' && Application.quantity.maxNumber == 1) {
				nextScreen = _.find(Application.general.storyboard, function(ecran){
					if(ecran.rank > nextScreen.rank && ecran.status == true) return ecran;
				})
			}
			//

			if(previousScreen) Application.previousScreen = previousScreen;
			if(nextScreen) Application.nextScreen = nextScreen;
			return resolve('ok');
		})
	}

	return Application;
}



// WEBPACK FOOTER //
// ./client/app/application/application.factory.js